import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import config from '../config'

function NotFound() {
  const navigate = useNavigate()
  const location = useLocation()
  const token = localStorage.getItem(config.token_name) || sessionStorage.getItem(config.token_name)
  const isAuthenticated = Boolean(token)
  const primaryActionPath = isAuthenticated ? '/home' : '/login'
  const primaryActionLabel = isAuthenticated ? 'กลับไปหน้า Dashboard' : 'เข้าสู่ระบบ'
  const statusCode = isAuthenticated ? '404' : '401'
  const title = isAuthenticated ? 'ไม่พบเส้นทางที่ต้องการเปิด' : 'ไม่มีสิทธิ์เข้าใช้งานหน้านี้'
  const description = isAuthenticated
    ? 'ลิงก์นี้ไม่มีอยู่ในระบบ หรือเส้นทางถูกเปลี่ยนแล้ว กรุณากลับไปยังหน้าหลักของระบบ'
    : 'คุณยังไม่ได้เข้าสู่ระบบ หรือ session หมดอายุ ระบบจะพาไปยังหน้าเข้าสู่ระบบโดยอัตโนมัติ'

  useEffect(() => {
    if (isAuthenticated) {
      return undefined
    }

    const redirectTimer = window.setTimeout(() => {
      navigate('/login', {
        replace: true,
        state: {
          from: location.pathname,
          reason: 'auth-required'
        }
      })
    }, 1200)

    return () => window.clearTimeout(redirectTimer)
  }, [isAuthenticated, location.pathname, navigate])

  return (
    <div className="app-empty-state">
      <div className="app-empty-state__panel">
        <p>CMU Landscape</p>
        <h1>{statusCode}</h1>
        <h2 className="app-empty-state__headline">{title}</h2>
        <p>{description}</p>
        <div className="app-empty-state__context">Path: {location.pathname}</div>
        <div className="app-empty-state__actions">
          <Link className="app-empty-state__primary-action" to={primaryActionPath}>
            {primaryActionLabel}
          </Link>
          {isAuthenticated && (
            <Link className="app-empty-state__secondary-action" to="/">
              กลับหน้าแรกของระบบ
            </Link>
          )}
        </div>
      </div>
    </div>
  )
}

export default NotFound